export default "__VITE_ASSET__c8ad3f3f__"